import { EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { createFeatureSelector } from '@ngrx/store';

export interface ISheetViewState {
    isOpen: boolean;
    optionGroupId?: string;
    sourceOptionGroup?: Pick<EventOptionGroup, 'options'>;
}

export const sheetViewInitialState: ISheetViewState = {
    isOpen: false,
    optionGroupId: undefined,
    sourceOptionGroup: undefined,
};

export const sheetViewStateKey = 'optionSheetView';

export const sheetViewStateSelector = createFeatureSelector<ISheetViewState>(sheetViewStateKey);
